import axios from 'axios';

class ProveedoresDataService {
  getAll() {
    return axios.get(`/api/proveedores`);
  }

  get(id) {
    return axios.get(`/api/proveedores/${id}`);
  }

  create(data) {
    return axios.post(`/api/proveedores`, data);
  }

  update(id, data) {
    return axios.put(`/api/proveedores/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/proveedores/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/proveedores`);
  }
}

export default new ProveedoresDataService();